// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"9ed8f429","321":"971485cf","538":"28913dbb","635":"37e7ac99","661":"0ba5c758","717":"01e74f09","787":"56ef3854","838":"f0244234","915":"5396120e"}[chunkId] + ".chunk.js";
};